module.exports = __webpack_public_path__ + "img/fm-Path 35 Copy@3x.d8363135.png";